import i18n from '@/plugins/i18n';
import { BaseNotification } from '@notify/models/notification/types/base';

export default class DefaultNotification extends BaseNotification {
  constructor(data) {
    super(data);
  }
  getTheme() {
    return BaseNotification.THEME_WARNING;
  }

  getText() {
    const { text_body, file_name } = this.getI18nProps();
    return `${text_body} ${file_name}`;
  }

  getI18nProps() {
    const {
      type,
      params: { file_name }
    } = this;

    return {
      text_body: i18n.t(`notify.notification.${type}.body`),
      file_name
    };
  }
}
